import axiosInstance from './axiosInstance';

export const adminApi = {
  getAdmins: (params) => axiosInstance.get('/admins', { params }),
  createAdmin: (data) => axiosInstance.post('/admins', data),
  toggleStatus: (id, status) => axiosInstance.patch(`/admins/${id}/status`, { status }),
  resetPassword: (id, newPassword) => axiosInstance.put(`/admins/${id}/reset-password`, { newPassword }),
  deleteAdmin: (id) => axiosInstance.delete(`/admins/${id}`)
};
